import { render, staticRenderFns } from "./FormInteresse.vue?vue&type=template&id=1704646d&scoped=true&"
import script from "./FormInteresse.vue?vue&type=script&lang=js&"
export * from "./FormInteresse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1704646d",
  null
  
)

export default component.exports